import type { ColSize } from 'antd/es/grid/col'

export const USER_CONTROL_COL = {
  segmented: { flex: 'none' },
  select: { flex: '0 0 13rem' },
  switch: { flex: '0 0 13rem' },
  input: { flex: '0 0 13rem' },
  dateRange: { flex: '0 0 16rem' },
  // Grows to fill the row beside the reload button; 13rem keeps it on one row at 320px viewports.
  dateRangeMobile: { flex: '1 0 13rem' },
} satisfies Record<string, ColSize>
